// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore} from 'firebase/firestore';
import { getMessaging, onMessage, getToken } from "firebase/messaging";
import { onBackgroundMessage } from "firebase/messaging/sw";// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyDDTH8nZWr7t3eZvqfhLZ4Nc_YmSJOczjE",
    authDomain: "copypaste-7f0db.firebaseapp.com",
    projectId: "copypaste-7f0db",
    storageBucket: "copypaste-7f0db.appspot.com",
    messagingSenderId: "822301117825",
    appId: "1:822301117825:web:5145ad852cbea43023ac80",
    measurementId: "G-VZ5BGTNLSQ",

  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const messaging = getMessaging(app);
const analytics = getAnalytics(app);
// Add the public key generated from the console here.

// function requestPermission() {
//   console.log('Requesting permission...');
//   Notification.requestPermission().then((permission) => {
//     console.log('Requesting permission...2');
//     if (permission === 'granted') {
//       console.log('Notification permission granted.');
//     }
//   });
// }

// requestPermission();
// getToken(messaging, { vapidKey: 'BEirp6mHwqebZrWFZqJimSXhtxA_zoWCjTLcOrmdGQGEvjAeHHoUOrJgfhqbwT--OI4DQVBLCgOj-a8oxtiyvn8' }).then((currentToken) => {
//   if (currentToken) {
//     // Send the token to your server and update the UI if necessary
//     // ...
//     console.log('currentToken: ');
//     console.log(currentToken);
//   } else {
//     // Show permission request UI
//     console.log('No registration token available. Request permission to generate one.');
//     // ...
//   }
// }).catch((err) => {
//   console.log('An error occurred while retrieving token. ', err);
//   // ...
// });

// const messaging = getMessaging();
//     onMessage(messaging, (payload) => {
//         console.log('Myfirebase Message received. ', payload);
//         // ...
//     });

//     onBackgroundMessage(messaging, (payload) => {
//         console.log('Myfirebase Received background message ', payload);
//         // Customize notification here
//         const notificationTitle = 'Background Message Title';
//         const notificationOptions = {
//             body: 'Background Message body.',
//             icon: '/firebase-logo.png'
//         };

//         // self.registration.showNotification(notificationTitle,
//         //   notificationOptions);
//     });
export const myFirestore = getFirestore(app);
export const messaging = getMessaging(app);

